window.dataTableAnqip = function (className) {
  function processColumnNodes() {
    // see https://datatables.net/reference/type/selector-modifier
    const tbl = $(`#${className}`).DataTable();
    var selector_modifier = { order: 'current', page: 'current', search: 'applied' }

    var previous = '';
    var officeNodes = tbl.column(0, selector_modifier).nodes();
    var officeData = tbl.column(0, selector_modifier).data();
    for (var i = 0; i < officeData.length; i++) {
      var current = officeData[i];
      if (current === previous) {
        officeNodes[i].textContent = '';
        officeNodes[i].setAttribute("style", "border-top:none;");
      } else {
        officeNodes[i].textContent = jQuery('<div>').html(current).text();
      }
      previous = current;
    }
  }
  $(document).ready(function() {

    const table = $(`#${className}`).DataTable({
      paging: true,

      layout: {
        topStart: {
          paging: {
            numbers:false,
            firstLast:false,
            previousNext:true
          }
        },
        bottomEnd: {
          paging: {
            numbers:false,
            firstLast:false,
            previousNext:true
          }
        }
      },
      lengthMenu:[25],
      searching: true,
      language: {
        search: trans('all.Search') + " : ",
        paginate: {
          first: "First",
          last: "Last",
          next: trans('pagination.next'),
          previous: trans('pagination.previous'),
        },
        lengthMenu: '',
        info: trans('all.info'),
      },
      drawCallback:function (settings, json) {
        processColumnNodes()
      },

    });


  });
}
